var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginNhanesPortalIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M13.5 22c-1.8 0-3.333-.633-4.6-1.9C7.633 18.833 7 17.3 7 15.5v-.575c-1.433-.233-2.625-.904-3.575-2.013C2.475 11.804 2 10.5 2 9V3h3V2h2v4H5V5H4v4c0 1.1.392 2.042 1.175 2.825C5.958 12.608 6.9 13 8 13s2.042-.392 2.825-1.175C11.608 11.042 12 10.1 12 9V5h-1v1H9V2h2v1h3v6c0 1.5-.475 2.804-1.425 3.912-.95 1.109-2.142 1.78-3.575 2.013v.575c0 1.25.438 2.313 1.313 3.188C11.187 19.563 12.25 20 13.5 20c1.25 0 2.313-.438 3.188-1.313S18 16.75 18 15.5v-1.675a2.91 2.91 0 0 1-1.438-1.075A2.906 2.906 0 0 1 16 11c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 19 8c.833 0 1.542.292 2.125.875S22 10.167 22 11c0 .65-.188 1.233-.563 1.75A2.91 2.91 0 0 1 20 13.825V15.5c0 1.8-.633 3.333-1.9 4.6-1.267 1.267-2.8 1.9-4.6 1.9Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M19 12c.283 0 .52-.096.712-.287A.968.968 0 0 0 20 11a.968.968 0 0 0-.288-.713A.968.968 0 0 0 19 10a.968.968 0 0 0-.712.287A.968.968 0 0 0 18 11c0 .283.096.52.288.713.191.191.429.287.712.287Z"
}))));
export default SvgPluginNhanesPortalIcon;